<template>
  <router-view />
</template>

<script>
import LogoutTimeout from '@/utils/logaut_timeout'

export default {
  mixins: [LogoutTimeout]
}
</script> 

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
